<!-- start page title -->
<app-pagetitle title="FAQs" [breadcrumbItems]="breadCrumbItems"></app-pagetitle>
<!-- end page title -->

<div class="row">
  <div class="col-lg-12">
    <!-- end row -->

    <div ngbAccordion [closeOthers]="true">
      @for (data of FaqsData; track $index) {
        <div ngbAccordionItem>
          <h2 ngbAccordionHeader>
            <button ngbAccordionButton>{{ data.title }}</button>
          </h2>
          <div ngbAccordionCollapse>
            <div ngbAccordionBody>
              <ng-template>
                {{ data.content }}
              </ng-template>
            </div>
          </div>
        </div>
      }
    </div>
  </div>
  <!-- end col -->
</div>
<!-- end row -->
